import { useState } from 'react';

const useClipboardAutoFill = (form) => {
  const [inputValue, setInputValue] = useState({});

  const handleInputClick = async (fieldPath) => {
    try {
      const clipboardText = await navigator.clipboard.readText();
      // if(!clipboardText){
      //   return false
      // }
      console.log(fieldPath,fieldPath.join('.'),  'copy peast' )
      setInputValue((prevValues) => ({
        ...prevValues,
        [fieldPath.join('.')]: clipboardText || "" // Join the fieldPath to form a nested key
      }));
      if (form) {
        setFormFieldValue(form,fieldPath,clipboardText )
        // form.setFieldsValue({ [fieldPath]: clipboardText || "" }); // Update the specific form field
      }
      await navigator.clipboard.writeText('');

    } catch (err) {
      console.error('Failed to read clipboard contents: ', err);
    }
  };

  function setFormFieldValue(form, fieldPath, value) {
    const pathArray = Array.isArray(fieldPath)
      ? fieldPath
      : fieldPath.split('.');
  
    const nestedObject = pathArray.reduceRight((acc, key) => ({ [key]: acc }), value);
  
    console.log('Setting field:', JSON.stringify(nestedObject, null, 2));
    form.setFieldsValue(nestedObject);
  }
  

  const handleInputChanges = (e, fieldPath) => {
    const value = e.target.value;
    setInputValue((prevValues) => ({
      ...prevValues,
      [fieldPath.join('.')]: value // Join the fieldPath to form a nested key
    }));
    if (form) {
      setFormFieldValue(form,fieldPath,value )
    }
  };

  return { inputValue, handleInputClick, handleInputChanges };
};

export default useClipboardAutoFill;
